// extracted by mini-css-extract-plugin
export default {"feesContainer":"Fees_feesContainer__Y3U6n","header":"Fees_header__mx-iI"};